<template>
    <div class="form">
        <a-card title="编辑">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-form-model-item label="钉钉群名" prop="dingdingname">
                    <a-input v-model="record.dingdingname" />
                </a-form-model-item>
                <a-form-model-item label="钉钉群Token" prop="dingdingurl">
                    <a-input v-model="record.dingdingurl" />
                </a-form-model-item>
                <a-form-model-item label="告警范围" prop="flag">
                    <a-select v-model="record.flag" placeholder="请选择告警范围">
                        <a-select-option value="01">
                            所有
                        </a-select-option>
                        <a-select-option value="02">
                            指定接口
                        </a-select-option>
                        <a-select-option value="03">
                            指定系统
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="告警内容" prop="types">
                    <a-checkbox-group v-model="record.types">
                        <a-checkbox value="SLA" name="types">
                            SLA
                        </a-checkbox>
                        <a-checkbox value="JOB" name="types">
                            JOB
                        </a-checkbox>
                    </a-checkbox-group>
                </a-form-model-item>
                <a-form-item label="是否开启">
                    <a-radio-group v-model="record.switch">
                        <a-radio value="1">
                            开启
                        </a-radio>
                        <a-radio value="0">
                            关闭
                        </a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-model-item :wrapper-col="{ span: 14, offset: 10 }">
                    <a-button type="primary" @click="handleOk">
                        保存
                    </a-button>

                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>

        </a-card>
    </div>

</template>
<script>
export default {
    data() {
        return {
            is_vue_task: false,
            labelCol: { span: 3 },
            wrapperCol: { span: 14 },
            rules: {
                dingdingname: [
                    {
                        required: true,
                        message: '请输入钉钉群名',
                        trigger: 'blur',
                    },
                    { max: 50, message: '不能超过50位', trigger: 'blur' },
                ],
                dingdingurl: [
                    {
                        required: true,
                        message: '请输入钉钉群Token',
                        trigger: 'blur',
                    },
                    { max: 100, message: '不能超过100位', trigger: 'blur' },
                ],
                types: [
                    {
                        type: 'array',
                        required: true,
                        message: '请选择告警类型',
                        trigger: 'change',
                    },
                ],
                flag: [
                    {
                        required: true,
                        message: '请选择告警范围',
                        trigger: 'change',
                    },
                ],
            },
            confirmLoading: false,
            formItemLayout: 'horizontal',
            actiontype: '',
            record: {
                id: '',
                dingdingname: '',
                dingdingurl: '',
                switch: '1',
                flag: '',
                types: [],
            },
        }
    },
    computed: {},

    methods: {
        handleOk() {
            this.confirmLoading = true
            let param = {}
            param.dingdingname = this.record.dingdingname
            param.dingdingurl = this.record.dingdingurl
            param.flag = this.record.flag
            param.switch = this.record.switch
            param.types = this.record.types.join(',')

            if (this.actiontype == 'dingdingadd') {
                //新增
                this.$store
                    .dispatch({
                        type: 'alarmconfig/dingdingadd',
                        params: param,
                    })
                    .then((response) => {
                        if (response.data.success == '1') {
                            this.$router.push({
                                path: 'dingdinglist',
                            })
                        }
                    })
            } else {
                //编辑
                param.id = this.record.id
                this.$store
                    .dispatch({
                        type: 'alarmconfig/dingdingedit',
                        params: param,
                    })
                    .then((response) => {
                        if (response.data.success == '1') {
                            console.log(response)
                            this.handleCancel()
                            this.confirmLoading = false
                        }
                    })
            }
        },

        handleChange(value) {
            this.record.syscode = value
        },
        handleCancel() {
            this.resetForm()
            this.$router.back(-1)
        },
        resetForm() {
            this.$refs.ruleForm.resetFields()
        },
    },

    mounted() {
        const { query, params } = this.$route
        this.is_vue_task = params.action == 'dingdingadd'
        this.actiontype = params.action
        if (params.action != 'dingdingadd') {
            this.$store
                .dispatch({
                    type: 'alarmconfig/dingdingdetails',
                    params: query,
                    showMsg: false,
                })
                .then((res) => {
                    let result = res.data.data
                    if (res) {
                        this.record.id = result.id
                        this.record.dingdingname = result.dingdingname
                        this.record.dingdingurl = result.dingdingurl
                        this.record.flag = result.flag
                        this.record.switch = result.switch
                        this.record.types = result.types
                            ? result.types.split(',')
                            : []
                    }
                })
        }
    },
}
</script>

<style scoped>
.ant-form-inline .ant-form-item {
    margin-right: 40px;
}
.form_span {
    font-size: 14px;
    font-weight: bolder;
}
</style>
